import DateTimeP from "./DateTimeP.mjs";
import PromoTypes from "./PromoTypes.mjs";
import PromoPerks from "./PromoPerks.mjs";

export default function Promo({
  promo,
  promoTypes,
  promoPerks,
  propertyPerks,
  versePerks,
}) {
  const dateTimeDesc = promo.shortDescription ? (
    <p className="label-2">{promo.shortDescription}</p>
  ) : (
    <DateTimeP
      startDate={promo.startDate}
      endDate={promo.endDate}
      startTime={promo.startTime}
      endTime={promo.endTime}
    />
  );
  const shortDesc = promo.shortDescriptionHeader ? (
    <p className="subhead-2 lh-base text-primary mb-2">
      {promo.shortDescriptionHeader}
    </p>
  ) : null;
  const promoTypeElements = (
    <PromoTypes promo={promo} promoTypesTax={promoTypes} />
  );

  const mergedPerks = [...promoPerks, ...propertyPerks, ...versePerks];
  const perks = <PromoPerks promo={promo} perkTax={mergedPerks} />;

  const viewDetails = promo.earnPeriodDescription ?? promo.occurrenceDetails;
  const viewMoreDetailsUrl = promo.detailsUrl ? (
      <a href={promo.detailsUrl} className="btn btn-link mt-2">
        View Complete Details
        <span className="material-icons">arrow_forward</span>
      </a>
  ) : (
    false
  );

  const moreDetails = viewDetails ? (
    <div className="">
      <div
        id={`accordion-${promo.eventId}`}
        className="accordion accordion-flush accordion-"
        style={{'--bs-accordion-border-width': 0}}
        role="list"
      >
        <div className="accordion-item" role="listitem">
          <p className="accordion-header">
            <button
              className="accordion-button collapsed btn btn-subtle btn-subtle-primary btn-icon flex-row-reverse gap-2"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#accordion-${promo.eventId}-item-1`}
              aria-expanded="false"
              aria-controls={`accordion-${promo.eventId}-item-1`}
              style={{'--bs-accordion-btn-icon-width': '.75rem'}}
            >
              View Details
            </button>
          </p>

          <div
            id={`accordion-${promo.eventId}-item-1`}
            className="accordion-collapse collapse"
            data-bs-parent={`#accordion-${promo.eventId}`}
          >
            <div className="accordion-body py-0 px-2 mt-2 px-lg-0">
              <div
                dangerouslySetInnerHTML={{ __html: viewDetails }}
              ></div>

              {viewMoreDetailsUrl}
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    false
  );

  const cardClass = "card-promo bg-white rounded shadow p-2 pb-3 p-lg-3";

  return (
    <>
      <div className={cardClass}>
        <div className="row gy-3 gy-md-2">
          <div className="col-12">
            <h4 className="text-dark-subtle mb-0">{promo.name}</h4>
          </div>
          <div className="col-md-6">
            <img
              src={promo.imageUrl}
              alt={promo.imageAlt}
              className="card-promo-image align-self-center rounded card-promo-not-featured"
            />
          </div>
          <div className="col-md-6">
            <div className="d-flex flex-column gap-4 gap-md-3 px-2 px-lg-0">
              <div className="text-wrap">
                {shortDesc}
                {dateTimeDesc}
              </div>
              {perks}
              <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mt-auto">
                {promoTypeElements}
              </div>
            </div>
          </div>
          <div className="col-12">{moreDetails}</div>
        </div>
      </div>
    </>
  );
}
